import { times } from "ramda";

export function selectOptions(min, max) {
  return [
    0,
    ...times(function (i) {
      return min + i;
    }, max - min + 1),
  ];
}
